import { Fragment } from "react";
import { FilterFields, FilterFieldsKeys } from "../../../types/FilterFields";
import ChainNameSingleSelection from "./components/ChainNameSingleSelection";
import CurrencySingleSelection from "./components/CurrencySingleSelection";
import { genField } from "src/utils/HelperComp";
import { useTranslation } from "src/hooks";
import WalletAddressTextField from "./components/WalletAddressTextField";
import { cleanStrArray } from "src/utils/helper";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";

function useRenderFilterFields() {
  const { translatePrefix, fields, setFields } =
    usePageConfigProviderContext<FilterFields>();

  const { t } = useTranslation(translatePrefix);

  const filterFields = genField({ t }, [
    [
      FilterFieldsKeys.ChainName,
      <ChainNameSingleSelection
        value={fields[FilterFieldsKeys.ChainName]}
        onChange={(value) => {
          setFields((fields) => ({
            ...fields,
            [FilterFieldsKeys.ChainName]: value,
            [FilterFieldsKeys.Currency]: "",
          }));
        }}
      />,
    ],
    [
      FilterFieldsKeys.Currency,
      <CurrencySingleSelection
        value={fields[FilterFieldsKeys.Currency]}
        onChange={(value) => {
          setFields((fields) => ({
            ...fields,
            [FilterFieldsKeys.Currency]: value,
          }));
        }}
        chainName={fields[FilterFieldsKeys.ChainName]}
      />,
    ],
    [
      FilterFieldsKeys.ClientId,
      <WalletAddressTextField
        value={fields[FilterFieldsKeys.ClientId]}
        onChange={(value) => {
          setFields((fields) => ({
            ...fields,
            [FilterFieldsKeys.ClientId]: value,
          }));
        }}
        count={
          cleanStrArray(fields[FilterFieldsKeys.ClientId].split(",")).length
        }
      />,
    ],
  ]);

  const renderFields = () =>
    Object.keys(filterFields).map((key, index) => (
      <Fragment key={index}>{filterFields[key]}</Fragment>
    ));

  return { renderFields };
}

export default useRenderFilterFields;
